<template>
    <b-card no-body>
        <b-card-body >
            <b-card-text >
                <b-row>
                    <b-col cols="12" md="6">
                        <label for="date-from-seller">Desde</label>
                        <b-form-datepicker placeholder="Seleccione Desde" id="date-from-seller" v-model="filter.dateFrom" />
                    </b-col>
                    <b-col cols="12" md="6">
                        <label for="date-to-seller">Hasta</label>
                        <b-form-datepicker id="date-to-seller" v-model="filter.dateTo" />
                    </b-col>
                    <b-col cols="12" md="12" class="pt-2">
                        <div>
                            <b-button variant="info" @click.prevent="$emit('search-result')" class="mx-1">
                                <b-icon icon="search" aria-hidden="true"></b-icon>
                                Buscar
                            </b-button>
                            <b-button variant="warning" @click.prevent="$emit('clear-filter-form')" class="mx-1 text-white">
                                <b-icon icon="backspace" aria-hidden="true"></b-icon>
                                Limpiar
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-card-text>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    name: "FilterForm",
    props: {
        filter: {
            type: Object,
            required: true,
        },
    },
};
</script>
